import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfileService from "../../services/Profile";
import TraderCardAPI from "../trade signal/components/TraderCardAPI";
import { FaArrowLeft } from "react-icons/fa6";

function TopTradersPage() {
  const [traders, setTraders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTraders = async () => {
      try {
        const { data } = await ProfileService.getTopTraders();

        setTraders(data.data.docs);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTraders();
  }, []);

  if (loading) {
    return <div className="py-20 text-center">Loading...</div>;
  }

  return (
    <section className="max-w-5xl mx-auto px-4 py-10 pb-32 pt-32">
      <header className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4 flex items-center justify-between border-b border-gray-100">
        <button
          onClick={() => navigate("/topSignals")}
          className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
        >
          <FaArrowLeft className="text-gray-600" />
        </button>
        <div className="text-center">
          <h1 className="text-lg font-bold text-gray-900">All Top Traders</h1>
        </div>
        <div className="w-10"></div>
      </header>

      <div className="space-y-4">
        {traders.map((trader, index) => (
          <TraderCardAPI key={trader._id} trader={trader} index={index} />
        ))}
      </div>
    </section>
  );
}

export default TopTradersPage;
